import { render } from "./SmallHeader.vue?vue&type=template&id=736a2664"
import script from "./SmallHeader.vue?vue&type=script&lang=js"
export * from "./SmallHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__